/* import __COLOCATED_TEMPLATE__ from './ticket-type-pill.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();